<h2 mat-dialog-title>{{'contract_share_partner.manage_share_with_partners' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>

<div class="editable-row my-3">
    <nz-input-group [nzSuffix]="suffixPartyInput2">
        <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
            [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                              'contract_share_partner.enter_partner_customer' | translate
                            }}" #focusPartyInput id="inputParty" />
        <nz-autocomplete #autoPartySearching>
            <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                                autocompletePartySelected($event, party)
                              " [nzValue]="''">
                <div class="d-flex">
                    <mat-icon class="mr-2">account_circle</mat-icon>
                    <span style="line-height: 20px">
                        {{ party.name }} -
                        {{
                        party.taxCode && party.taxCode.length > 0
                        ? party.taxCode
                        : party.certificateNo
                        }}
                    </span>
                </div>
                <div class="d-flex">
                    <mat-icon class="mr-2">contact_mail</mat-icon>
                    <span style="line-height: 20px">
                        <span *ngIf="party.email">{{ party.email }} -</span>
                        {{ party.phone }}
                    </span>
                </div>
                <hr style="margin: 0; padding: 0" />
            </nz-auto-option>
        </nz-autocomplete>
    </nz-input-group>
    <ng-template #suffixPartyInput2>
        <nz-spin *ngIf="nzCheckLoadingParty2" nzSimple [nzIndicator]="indicatorPartyInput2"></nz-spin>
    </ng-template>
    <ng-template #indicatorPartyInput2><i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px"></i>
    </ng-template>
</div>
<div class="table-container">
    <nz-table #editRowSharePartnerTable nzBordered [nzData]="RECORD_SHARE_PARTNER" [nzShowPagination]="false"
        [nzNoResult]="contentEmptyTable1" [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
            <tr>
                <th class="text-center" nzWidth="35px">
                    {{
                    "view_document_information.table_headers.signingApostropheContractUnit.no"
                    | translate
                    }}
                </th>
                <th class="text-center" nzWidth="65%">
                    {{
                    "view_document_information.table_headers.signingApostropheContractUnit.member"
                    | translate
                    }}
                </th>
                <th class="text-center" nzWidth="150px">
                    {{ 'contract_share_partner.view_permission' | translate }}
                </th>
                <th class="text-center" nzWidth="47px"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of editRowSharePartnerTable.data; let i = index" class="editable-row">
                <!-- TT -->
                <td class="text-center">{{ i + 1 }}</td>
                <!-- Tên -->
                <td class="word-break-line">
                    <div class="editable-cell">
                        <div class="row-icon"> {{ data.name }} <span *ngIf="data.email"> - {{ data.email }}</span><span
                                *ngIf="data.phone"> - {{ data.phone }}</span></div>
                    </div>
                </td>
                <td>
                    <div class="d-flex align-items-center justify-content-center cursor-pointer"
                        [matMenuTriggerFor]="menuFeature">
                        <div>
                            <span *ngIf="data.permission == 'FILE'">{{'contract_share_partner.view_file_contract' |
                                translate}}</span>
                            <span *ngIf="data.permission == 'FULL'">{{'contract_share_partner.view_detail_contract' |
                                translate}}</span>
                        </div>
                        <div>
                            <button mat-icon-button>
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            </button>
                            <mat-menu #menuFeature="matMenu">
                                <button mat-menu-item (click)="data.permission = 'FILE';isChange = true"
                                    [ngClass]="{'active': data.permission == 'FILE'}">
                                    {{'contract_share_partner.view_file_contract' | translate}}
                                </button>
                                <button mat-menu-item (click)="data.permission = 'FULL';isChange = true"
                                    [ngClass]="{'active': data.permission == 'FULL'}">
                                    {{'contract_share_partner.view_detail_contract' | translate}}
                                </button>
                            </mat-menu>
                        </div>
                    </div>
                </td>
                <!-- Action -->
                <td class="td-nz-icon text-center">
                    <button (click)="onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)" aria-label="Clear"
                        mat-button mat-icon-button matSuffix style="color: #ee0033" type="button">
                        <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                    </button>
                </td>
            </tr>

        </tbody>
    </nz-table>
</div>
<ng-template #contentEmptyTable1></ng-template>

<mat-dialog-actions align="center" class="mt-2" class="action">

    <button mat-stroked-button color="primary" (click)="close()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>

    <button mat-raised-button color="primary" class="ml-3" (click)="save()" type="button"
            [disabled] = "!isChange">
      <mat-icon class="mr-0">done_all</mat-icon>
      {{'button.save' | translate}}
    </button>
  </mat-dialog-actions>